import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Autocomplete from "@mui/material/Autocomplete";
import Button from "@mui/material/Button";
import Checkbox from "@mui/material/Checkbox";
import Grid from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import React, { useEffect, useState } from "react";
import {
  ARTICLE_URL,
  SOLUTION_URL,
  TICKET_SOLUTIONS_URL,
} from "../../Constants/Constants";
import AxiosInstance from "./../../services/AxiosInstance";

import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { isEmpty } from "../../Constants/RolesConstants";
import AppTableView from "../AppTableView";
import { ThemeProvider } from "../v2/home/theme/ThemeProvider";
import { useAlert } from "../alerts/AlertContext";
import { STATUS_CLOSED_ID } from '../../Constants/StatusConstants'

const Solution = (props) => {
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

  const [data, setData] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [articles, setArticles] = useState([]);

  const showAlert = useAlert();

  const handleChange = (event, value) => {
    setSelectedOption(value);
    console.log("Selected option:", value);
  };

  useEffect(() => {
    getArticles();
    getTicketSolutions();
  }, []);

  const getArticles = async () => {
    await AxiosInstance.get(ARTICLE_URL).then((response) =>
      setArticles(response.data.data)
    );
  };

  const addSolutions = async () => {
    const solution = {
      ticketId: props.ticketId,
      articles: selectedOption,
    };

    await AxiosInstance.post(SOLUTION_URL, solution)
      .then((response) => {
        showAlert("Solution added successfully!", "success");
        getTicketSolutions();
      })
      .catch((error) => {
        showAlert("Solution adding failed!", "error");
        console.error(error);
      });
  };

  const getTicketSolutions = async () => {
    await AxiosInstance.get(TICKET_SOLUTIONS_URL + props.ticketId).then(
      (response) => setData(response.data)
    );
  };

  return (
    <ThemeProvider>
      <Box sx={{ padding: "20px", bgcolor: "background.default" }}>
        <Grid container spacing={2} columns={16}>
          <Grid size={10}>
            <Autocomplete
              multiple
              limitTags={2}
              id="checkboxes-tags-demo"
              size="small"
              options={articles}
              onChange={handleChange}
              disableCloseOnSelect
              getOptionLabel={(option) => option.title}
              renderOption={(props, option, { selected }) => {
                const { key, ...optionProps } = props;
                return (
                  <li key={key} {...optionProps}>
                    <Checkbox
                      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                      checkedIcon={<CheckBoxIcon fontSize="small" />}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.title}
                  </li>
                );
              }}
              style={{ width: "100%" }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Solutions"
                  placeholder="Articles"
                />
              )}
            />
          </Grid>
          <Grid size={6}>
            {isEmpty(props?.componentPermissions) ||
            props?.componentPermissions?.["canUpdate"] ? (
              <Button
                variant="contained"
                color="primary"
                disabled={isEmpty(selectedOption) || props.statusId === STATUS_CLOSED_ID}
                onClick={!isEmpty(selectedOption) ? addSolutions : null}
              >
                Add Solution
              </Button>
            ) : null}
          </Grid>
        </Grid>
        <br />
        {/* Table View */}
        {/* <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Article #</StyledTableCell>
                  <StyledTableCell>Title</StyledTableCell>
                  <StyledTableCell>Category Name</StyledTableCell>
                  <StyledTableCell>SubCategory Name</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {visibleRows.map((solution, index) => {
                  return (
                    <StyledTableRow key={solution.article.id}>
                      <StyledTableCell>{solution.article.id}</StyledTableCell>
                      <StyledTableCell>
                        <Tooltip title={solution.article.title}>
                          <span
                            style={{
                              display: "block",
                              maxWidth: 200,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {solution.article.title}
                          </span>
                        </Tooltip>
                      </StyledTableCell>
                      <StyledTableCell>
                        {solution.article.category.name}
                      </StyledTableCell>
                      <StyledTableCell>
                        {solution.article.subCategory.name}
                      </StyledTableCell>
                    </StyledTableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </Box> */}
        <AppTableView
          rows={data}
          cols={[
            {
              field: "id",
              headerName: "Article #",
              flex: 1,
              renderCell: (params) => params.row.id,
            },
            {
              field: "title",
              headerName: "Title",
              flex: 1,
              renderCell: (params) => params.row.title,
            },
            {
              field: "categoryName",
              headerName: "Category Name",
              flex: 1,
              renderCell: (params) => params.row.categoryName,
            },
            {
              field: "subCategoryName",
              headerName: "SubCategory Name",
              flex: 1,
              renderCell: (params) => params.row.subCategoryName,
            },
          ]}
          initialPageSize={5}
        />
      </Box>
    </ThemeProvider>
  );
};
export default Solution;
